import React, { useState } from 'react';

export default function LoginScreen({ onBack, onSuccess }) {
  const [isRegister, setIsRegister] = useState(false);
  const [form, setForm] = useState({ name:'', email:'', password:'' });
  const [error, setError] = useState('');

  function handleSubmit(e) {
    e.preventDefault();
    if (!form.email || !form.password) { setError('Preencha e-mail e senha.'); return; }
    if (isRegister && !form.name)      { setError('Informe seu nome.'); return; }
    setError('');
    onSuccess({ name: isRegister ? form.name : 'Rafael Silva', email: form.email }, isRegister);
  }

  return (
    <div style={{
      minHeight:'100vh',
      display:'flex',
      alignItems:'center',
      justifyContent:'center',
      padding:20,
      background:'var(--black)',
    }}>
      {/* bg glow */}
      <div style={{
        position:'fixed', top:'20%', left:'50%', transform:'translateX(-50%)',
        width:500, height:500, borderRadius:'50%',
        background:'radial-gradient(circle, rgba(255,92,0,0.08) 0%, transparent 65%)',
        pointerEvents:'none',
      }} />

      <div className="fade-up" style={{ width:'100%', maxWidth:420, position:'relative' }}>
        <button onClick={onBack} style={{
          background:'none', border:'none', color:'var(--grey-3)',
          fontSize:14, marginBottom:28, display:'flex', alignItems:'center', gap:6, cursor:'pointer',
        }}>
          ← Voltar
        </button>

        {/* Logo */}
        <div style={{ textAlign:'center', marginBottom:32 }}>
          <div style={{
            width:52, height:52, borderRadius:14,
            background:'var(--orange-dim)', border:'1.5px solid rgba(255,92,0,0.3)',
            display:'flex', alignItems:'center', justifyContent:'center',
            fontSize:26, margin:'0 auto 14px',
          }}>🔧</div>
          <div className="nav-logo" style={{ fontSize:26, marginBottom:6 }}>Auto<span style={{ color:'var(--orange)' }}>Fácil</span></div>
          <p style={{ color:'var(--grey-3)', fontSize:14 }}>
            {isRegister ? 'Junte-se a milhares de motoristas' : 'Entre na sua conta'}
          </p>
        </div>

        {/* Form */}
        <div style={{
          background:'var(--surface)',
          border:'1px solid var(--border)',
          borderRadius:'var(--radius-xl)',
          padding:28,
        }}>
          <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:14 }}>
            {isRegister && (
              <div>
                <label style={{ fontSize:12, fontWeight:600, color:'var(--grey-3)', display:'block', marginBottom:6 }}>NOME COMPLETO</label>
                <input className="input" placeholder="Seu nome" value={form.name} onChange={e => setForm(p => ({...p, name:e.target.value}))} />
              </div>
            )}
            <div>
              <label style={{ fontSize:12, fontWeight:600, color:'var(--grey-3)', display:'block', marginBottom:6 }}>E-MAIL</label>
              <input className="input" type="email" placeholder="seu@email.com" value={form.email} onChange={e => setForm(p => ({...p, email:e.target.value}))} />
            </div>
            <div>
              <label style={{ fontSize:12, fontWeight:600, color:'var(--grey-3)', display:'block', marginBottom:6 }}>SENHA</label>
              <input className="input" type="password" placeholder="••••••••" value={form.password} onChange={e => setForm(p => ({...p, password:e.target.value}))} />
            </div>

            {error && <p style={{ color:'#F87171', fontSize:13, textAlign:'center' }}>{error}</p>}

            <button className="btn btn-primary" type="submit" style={{ marginTop:8, width:'100%', justifyContent:'center', padding:16, fontSize:16 }}>
              {isRegister ? 'Criar minha conta' : 'Entrar'}
            </button>
          </form>

          {!isRegister && (
            <div style={{ display:'flex', gap:12, marginTop:16 }}>
              {['Uber','99'].map(app => (
                <button key={app} className="btn btn-ghost" style={{ flex:1, justifyContent:'center', padding:'10px 0', fontSize:13 }}>
                  Entrar com {app}
                </button>
              ))}
            </div>
          )}
        </div>

        <p style={{ textAlign:'center', marginTop:20, fontSize:14, color:'var(--grey-4)' }}>
          {isRegister ? 'Já tem conta? ' : 'Não tem conta? '}
          <button onClick={() => { setIsRegister(!isRegister); setError(''); }}
            style={{ background:'none', border:'none', color:'var(--orange)', fontWeight:600, cursor:'pointer', fontSize:14 }}>
            {isRegister ? 'Entrar' : 'Criar grátis'}
          </button>
        </p>
      </div>
    </div>
  );
}
